<template>
    <div>
        <div class="card-body" style="background-color: white;">
                <div class="container">
                    <div class="row">
<!--                        <div class="col-12">-->
<!--                            <label class="my-4" style="">How will the data flow?</label>-->
<!--                        </div>-->

                        <div class="col-md-4 float-left text-right">
                            <img style="width: 150px; margin-top: 35px;" :src="returnUrl('followup')">
                        </div>

                        <div class="col-md-4 float-left text-center">
                            <img class="and-logic-logo mt-4 pt-3" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/and-logic-new.png">
                        </div>
                        <div class="col-md-4 float-left text-left">
                            <img style="width: 150px; margin-top: 15px;" :src="returnUrl(connectedErpIntegration)">
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <label class="my-4">Module Mapping </label>
                        </div>
                        <div class="col-12" style="">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th class="col-3">Followup Module</th>
                                        <th class="col-3 capitalize">{{ connectedErpIntegration }} Module</th>
                                        <th class="col-3" >Field Mapping</th>
                                        <th class="col-1">ON/OFF</th>
                                        <th class="col-2">Import</th>
                                        <th class="col-1 text-center">Add/Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, moduleIndex) in moduleMappingData" :key="moduleIndex">
                                        <td>
                                            <div v-if="item.id !== 0" class="capitalize">
                                               {{item.followUp.replace(/-/g , ' ')}}
                                            </div>
                                            <b-form-select
                                                v-else
                                                v-model="item.followUp"
                                                :options="followupObjectOption"
                                                value-field="value"
                                                text-field="label"
                                                disabled-field="disabled"
                                                @change="changeModules(item, 'followup', moduleIndex)"
                                            ></b-form-select>
                                        </td>
                                        <td>
                                            <div v-if="item.id !== 0">
                                                {{item.thirdPartyLabel}}
                                            </div>
                                            <b-form-select
                                                v-else
                                                v-model="item.thirdParty"
                                                :options="thirdPartyObjectOptions"
                                                value-field="value"
                                                text-field="label"
                                                disabled-field="disabled"
                                                @change="changeModules(item, 'thirdParty', moduleIndex)"
                                            ></b-form-select>
                                        </td>
                                        <td>
                                           <div class="btn-link cursor-pointer" @click="viewFieldsMapping(item, moduleIndex)">View Mapped Fields</div>
                                        </td>
                                        <td><b-form-checkbox v-model="item.status" switch @change="updateFieldStatus(item)"></b-form-checkbox></td>
                                        <td v-if="item.fieldMappings.length === 0">
                                            <button
                                                disabled="disabled"
                                                v-if="item.followUp == 'Company' || item.followUp == 'Residential-contact'"
                                                type="button"
                                                class="btn btn-sm text-xs btn-secondary cursor-not-allowed import-button-disabled"
                                                @click.prevent="openImportCustomersModal(item)"
                                                title="Please map the mandatory fields to import customers">
                                                Import Customers
                                            </button>
                                        </td>
                                        <td v-else>
                                            <button
                                                v-if="item.followUp == 'Company' || item.followUp == 'Residential-contact'"
                                                type="button"
                                                class="btn btn-sm text-xs btn-primary"
                                                @click.prevent="openImportCustomersModal(item)">
                                                Import Customers
                                            </button>
                                        </td>
                                        <td class="text-center">
                                            <button v-if="item.id !== 0" type="button" class="btn btn-danger"
                                                    @click.prevent="deleteModule(item)">
                                                Delete
                                            </button>

                                            <button v-else type="button" class="btn" :class="item.fieldMappings.length === 0 ? 'btn-secondary' : 'btn-primary'" :disabled="item.fieldMappings.length === 0 || isAddButtonDisabled"
                                                    @click.prevent="saveModule(item)">
                                                Add
                                            </button>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
<!--                            <div v-if="showButtonMapping && moduleMappingData.length < 3" class="w-100 text-right">-->
                            <div v-if="moduleMappingData.length < (connectedErpIntegration === 'vista' ? 4 : 3)" class="w-100 text-right">
                                <button type="button" class="btn btn-primary"
                                        @click.prevent="addModuleMappingData()">
                                    Add Mapping
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
        </div>

        <b-modal id="fieldsMappingModal" size="xl" title="Field Mapping" :hide-footer="true" v-model="showFieldsMapping" >
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <button class="btn btn-link" @click="showFieldsMapping = false">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </template>
            <div id="loadingOverlayFetchVistaFields">
                <div class="cv-spinner">
                    <span class="spinner"></span>
                    <span class="text-white ml-4 text-xl ">{{ loadingMessage}}</span>
                </div>
            </div>
            <div class="container">
<!--                <h3>Field Mapping </h3>-->
                <div class="row">
                    <div class="col-md-4 float-left text-center flex justify-content-center align-items-center font-weight-bold capitalize">
                        {{ selectedFieldMappingObject.followUp.replace(/-/g , ' ') }}
                    </div>

                    <div v-if="connectedErpIntegration== 'vista' && selectedFieldMappingObject.followUp == 'Project-change-order'" class="col-md-4 float-left text-center">
                        <img style="width: 40px" :src="returnUrl('one-way-followup')">
                    </div>
                    <div v-else class="col-md-4 float-left text-center">
                        <button type="button" @click="changeModuleDirection" style="border: 1px solid black;border-radius: 5px;padding: 15px;background-color: white;">
                            <img style="width: 40px" :src="returnUrl(selectedFieldMappingObject.direction)">
                        </button>
                    </div>
                    <div class="col-md-4 float-left text-center flex justify-content-center align-items-center font-weight-bold">
                        {{ selectedFieldMappingObject.thirdPartyLabel}}
                    </div>
                </div>
                <div>
                    <table class="table table-bordered mt-4">
                        <thead>
                            <tr>
                                <th class="col-3">Followup Field</th>
                                <th class="col-2 text-center">Direction</th>
                                <th class="col-3 capitalize">{{ connectedErpIntegration }} Field</th>
                                <th class="col-1">ON/OFF</th>
                                <th class="col-1">Add/Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(fieldItem, index) in fieldMappingData" :key="fieldItem.id" :id="fieldItem.id">
                                <td>
                                    <div v-if="fieldItem.id !== 0 && editingModuleFieldIndex !== index">
                                        {{fieldItem.followUpLabel}} <span v-if="selectedFieldMappingObject.followUp == 'Company' && fieldItem.followUpObject == 'CompanyContact'"> (Contact)</span>
                                    </div>
                                    <b-form-select
                                        v-else
                                        v-model="fieldItem.followUp"
                                        :options="computedFollowUpFieldsOptions"
                                        value-field="value"
                                        text-field="label"
                                        disabled-field="disabled"
                                        @change="changeFields(fieldItem, 'followup', index)"
                                        filter
                                    ></b-form-select>
                                </td>
                                <td class="text-center">
                                    <button v-if="fieldItem.canChangeDirection"  type="button" @click="changeModuleFieldDirection(fieldItem)">
                                        <img style="width: 30px" :src="returnUrl(fieldItem.direction)">
                                    </button>
                                    <img v-else style="width: 30px" :src="returnUrl('one-way-followup')">

                                        <button v-if="connectedErpIntegration === 'vista' && ((fieldItem.is_custom_field && fieldItem.is_custom_field_dropdown) || ['account_manager_id', 'estimator_id', 'take_off_person_id'].includes(fieldItem.followUp.value)) && fieldItem.thirdParty === 'ProjectMgr'" @click.prevent="mapDropdownFields(fieldItem, index)" class="btn btn-sm btn-success ml-3">Map fields</button>
                                </td>
                                <td>
                                    <div v-if="fieldItem.id !== 0 && editingModuleFieldIndex !== index">
                                        {{fieldItem.thirdPartyLabel.replace(/_/g, ' ')}}
                                    </div>
                                    <b-form-select
                                        v-else
                                        v-model="fieldItem.thirdParty"
                                        :options="thirdPartyFieldsOptions"
                                        value-field="value"
                                        text-field="label"
                                        disabled-field="disabled"
                                        @change="changeFields(fieldItem, 'thirdParty', index)"
                                        filter
                                    ></b-form-select>
                                </td>
                                <td><b-form-checkbox v-model="fieldItem.status" switch></b-form-checkbox></td>
                                <td v-if="fieldItem.id !== 0 && editingModuleFieldIndex !== index" class="flex justify-content-between">
                                    <button type="button" class="btn btn-warning btn-sm"  @click.prevent="editModuleField(index)">
                                        Edit
                                    </button>
                                    <button type="button" class="btn btn-danger btn-sm"  @click.prevent="removeModuleField(index)">
                                        Delete
                                    </button>
                                </td>
                                <td v-else>
                                    <button v-if="editingModuleFieldIndex === index" type="button" class="btn btn-primary btn-sm"  @click.prevent="addModuleField(index)">
                                        Update
                                    </button>
                                    <button v-else type="button" class="btn btn-primary btn-sm"  @click.prevent="addModuleField(index)">
                                        Add
                                    </button>
                                </td>
                            </tr>

                        </tbody>
                    </table>

                    <div v-if="fieldMappingData.length < thirdPartyFieldsOptions.length" class="w-100 text-right">
                        <button type="button" class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-10 md:px-3 border-r-1 text-followup-nav"
                                @click.prevent="addModuleFieldMappingData()">
                            {{ fieldMappingData.length === 0 ?'Map field': 'Map another field' }}
                        </button>
                    </div>

                    <div v-if="fieldMappingData.length > 0 && showSaveFieldsButton" class="w-100 text-right mt-3">
                        <button type="button" class="btn btn-primary"
                                @click.prevent="saveModuleFields()">
                            Save
                        </button>
                    </div>
                    <div class="text-md mb-3">{{ fieldMappingNote }}</div>
                    <div class="text-sm text-danger" v-if="fieldMappingError">{{fieldMappingError}}</div>
                </div>
            </div>
        </b-modal>

        <b-modal id="syncedFieldOptions" size="lg" centered title="Dropdown Sync" :hide-footer="true" v-model="showSyncedFieldOptions" >
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <button class="btn btn-link" @click="showSyncedFieldOptions = false">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </template>
            <div id="loadingOverlayFetchFieldOptions">
                <div class="cv-spinner">
                    <span class="spinner"></span>
                    <span class="text-white ml-4 text-xl ">{{loadingDropdownOptionsMessage}}</span>
                </div>
            </div>
            <div class="container">
                <div class="row">

                    <table class="table table-bordered mt-4">
                        <thead>
                            <tr>
                                <th class="col-3">NAME</th>
                                <th class="col-3">DESCRIPTION</th>
                                <th class="col-2">LOAD ORDER</th>
                                <th class="col-1">ENABLED</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(syncedFieldOption, index) in syncedFieldOptions" :key="syncedFieldOption.id" :id="syncedFieldOption.id">
                                <td>
                                    {{syncedFieldOption.name}}
                                </td>
                                <td>
                                    {{syncedFieldOption.description}}
                                </td>
                                <td>
                                    {{syncedFieldOption.load_order}}
                                </td>
                                <td><b-form-checkbox v-model="syncedFieldOption.enabled" disabled :value="syncedFieldOption.enabled" ></b-form-checkbox></td>

                            </tr>
                        </tbody>
                    </table>

                    <div class="w-100 text-right">
                        <button type="button" class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-10 md:px-3 border-r-1 text-followup-nav"
                                @click.prevent="syncProjectManager(selectedFieldItem, selectedFieldIndex, true)">
                            Sync Again
                        </button>
                    </div>

                </div>
            </div>
        </b-modal>

        <div class="modal" tabindex="-1" role="dialog" id="importCustomerConfirmationModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">Import all <span class="capitalize">{{connectedErpIntegration}}</span> customers?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will import all the customers from <span class="capitalize">{{connectedErpIntegration}}</span>, as per the fields mapped. Do you want to proceed?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeImportCustomersModal()">No</button>
                        <button type="button" class="btn btn-primary" @click.prevent="importCustomers()">Yes</button>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="mapDropdownFieldOptions" size="lg" centered title="Map Dropdown" :hide-footer="true" v-model="showMapFieldOptions" >
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <button class="btn btn-link" @click="showMapFieldOptions = false">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </template>
            <div id="loadingOverlayFetchingFieldOptions">
                <div class="cv-spinner">
                    <span class="spinner"></span>
                    <span class="text-dark ml-4 text-xl ">{{loadingDropdownOptionsMessage}}</span>
                </div>
            </div>
            <div class="container">

                <div class="mapping-table">
                    <table class="table table-bordered mt-4">
                        <thead>
                        <tr>
                            <th class="col-3">{{ selectedMappingDropdownField.followUpLabel }}</th>
                            <th class="col-3">{{ selectedMappingDropdownField.thirdParty }} ({{connectedErpIntegration}})</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in dropdownFieldMappingData">
                            <td>
                                <b-form-select
                                    v-model="item.id"
                                    :options="dropdownOptions"
                                    value-field="id"
                                    text-field="name"
                                ></b-form-select>
                            </td>
                            <td>
                                <b-form-select
                                    v-model="item.third_party_id"
                                    :options="thirdPartyDropdownOptions"
                                    value-field="ProjectMgr"
                                    text-field="Name"
                                    @change="changeDropdownMappingField(index, item)"
                                ></b-form-select>
                            </td>

                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="w-100 text-right">
                    <button type="button" class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-10 md:px-3 border-r-1 text-followup-nav"
                           @click.prevent="saveDropdownOptions()" >
<!--                        check if all field have third_party_id-->
                        Save
                    </button>
                </div>

            </div>
        </b-modal>
    </div>
</template>


<script>

import axios from 'axios';
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";

export default {

    name: 'erp-integration-vista-settings',
    components: {Multiselect},
    props: ['team', 'bucketUrl', 'mappingData', 'connectedErpIntegration'],
    data() {
        const followUpObjects = this.connectedErpIntegration === 'vista' ? [
                {custom_id: 1, value:'Project', label:'Project', disabled: false},
                {custom_id: 2, value:'Company', label:'Company', disabled: false},
                {custom_id: 3, value:'Residential-contact', label:'Residential Contact', disabled: false},
                {custom_id: 4, value:'Project-change-order', label:'Project | Change Orders', disabled: false}
            ] :  [
            {custom_id: 1, value:'Project', label:'Project', disabled: false},
            {custom_id: 2, value:'Company', label:'Company', disabled: false},
            {custom_id: 3, value:'Residential-contact', label:'Residential Contact', disabled: false}
        ];


        return {
            erpIntegrationId: 0,
            direction:'two-ways',
            fieldDirection:'two-ways',
            // showButtonMapping: true,
            // showFieldButtonMapping: true,
            moduleMappingData: [],
            fieldMappingData: [],
            followupObjectOption:followUpObjects,
            thirdPartyObjectOptions:[],
            vistaObjectOption:[
                {custom_id: 1, value:'JCJM', label:'JC Jobs', disabled: false},
                {custom_id: 2, value:'ARCM', label:'AR Customers', disabled: false},
                {custom_id: 3, value:'ARCM', label:'AR Customers', disabled: false},
                {custom_id: 4, value:'ACO', label:'Change Order', disabled: false},
            ],
            spectrumObjectOption:[
                {custom_id: 1, value:'JC_JOB_MASTER_MC', label:'JOBS', disabled: false},
                {custom_id: 2, value:'CR_CUSTOMER_MASTER_MC', label:'CUSTOMERS', disabled: false},
                {custom_id: 3, value:'CR_CUSTOMER_MASTER_MC', label:'CUSTOMERS', disabled: false},
            ],
            showFieldsMapping: false,
            showSaveFieldsButton: false,
            selectedFieldMappingObject: {
                followUp: '',
                thirdParty: '',
                direction: 'two-ways',
                fieldMappings: [],
            },
            selectedFieldMappingIndex: null,
            followUpFieldsOptions: [],
            projectFields: [
                {value:'id', label:'Project Seq ID/Custom #', disabled: false, object_type:'Project'},
                {value:'job_number', label:'Auto-generated Job # based on vista Job# (N/A to alphanumeric)', disabled: false, object_type:'Project'},
                {value:'name', label:'Name', disabled: false, object_type:'Project'},
                {value:'address', label:'Address', disabled: false, object_type:'Project'},
                {value:'city', label:'City', disabled: false, object_type:'Project'},
                {value:'state', label:'State', disabled: false, object_type:'Project'},
                {value:'zip', label:'Zip Code', disabled: false, object_type:'Project'},
                {value:'base_bid', label:'Base Bid', disabled: false, object_type:'Project'},
                {value:'contract_amount', label:'Contract Amount', disabled: false, object_type:'Project'},
                {value:'contract_date', label:'Contract Date', disabled: false, object_type:'Project'},
                {value:'bid_date', label:'Bid Date', disabled: false, object_type:'Project'},
                {value:'pre_bid', label:'Pre Bid', disabled: false, object_type:'Project'},
                {value:'sales_status_id', label:'Sales Status', disabled: false, object_type:'Project'},
                {value:'marketing_status_id', label:'Marketing Status', disabled: false, object_type:'Project'},
                {value:'lead_from_id', label:'Lead From', disabled: false, object_type:'Project'},
                {value:'account_manager_id', label:'Account Manager', disabled: false, object_type:'Project'},
                {value:'estimator_id', label:'Estimator', disabled: false, object_type:'Project'},
                {value:'take_off_person_id', label:'Take Off Person', disabled: false, object_type:'Project'},
                {value:'client_profile_id', label:'Client Profile', disabled: false, object_type:'Project'},
                {value:'contract_type_id', label:'Contract Type', disabled: false, object_type:'Project'},
            ],
            contactFields: [
                {value:'id', label:'ID', disabled: false, object_type:'CompanyContact'},
                {value:'name', label:'Name', disabled: false, object_type:'CompanyContact'},
                {value:'email', label:'Email', disabled: false, object_type:'CompanyContact'},
                {value:'cell', label:'Cell', disabled: false, object_type:'CompanyContact'},
                {value:'title', label:'Title', disabled: false, object_type:'CompanyContact'},
                {value:'contact_types_id', label:'Contact Type', disabled: false, object_type:'CompanyContact'},
            ],
            residentialContactFields: [
                {value:'address', label:'Address', disabled: false, object_type:'CompanyContact'},
                {value:'city', label:'City', disabled: false, object_type:'CompanyContact'},
                {value:'state', label:'State', disabled: false, object_type:'CompanyContact'},
                {value:'zip', label:'Zip Code', disabled: false, object_type:'CompanyContact'}
            ],
            companyFields: [
                {value:'id', label:'ID', disabled: false, object_type:'Company'},
                {value:'name', label:'Name', disabled: false, object_type:'Company'},
                {value:'address', label:'Address', disabled: false, object_type:'Company'},
                {value:'city', label:'City', disabled: false, object_type:'Company'},
                {value:'state', label:'State', disabled: false, object_type:'Company'},
                {value:'zip', label:'Zip Code', disabled: false, object_type:'Company'},
                {value:'phone', label:'Phone', disabled: false, object_type:'Company'},
                {value:'fax', label:'Fax', disabled: false, object_type:'Company'},
                {value:'site', label:'Web Site', disabled: false, object_type:'Company'},
                {value:'company_type_id', label:'Company Type', disabled: false, object_type:'Company'},
            ],
            projectChangeOrderFields: [
                {value:'name', label:'Change Order Name', disabled: false, object_type:'ProjectChangeOrder'},
                {value:'base_bid', label:'Base Bid', disabled: false, object_type:'ProjectChangeOrder'},
                {value:'contract_amount', label:'Contract Amount', disabled: false, object_type:'ProjectChangeOrder'},
                {value:'contract_date', label:'Contract Date', disabled: false, object_type:'ProjectChangeOrder'},
                {value:'bid_date', label:'Bid Date', disabled: false, object_type:'ProjectChangeOrder'},
                {value:'gross_margin_percentage', label:'Gross Margin%', disabled: false, object_type:'ProjectChangeOrder'},
            ],
            thirdPartyFieldsOptions: [],
            // Todo pull this from constants
            agaveFields:{
                'JCJM': [
                    {value:'number', label:'Job', disabled: false, required: true},
                    {value:'name', label:'Description', disabled: false, required: true},
                    {value:'street_1', label:'MailAddress', disabled: false, required: true},
                    {value:'city', label:'MailCity', disabled: false, required: true},
                    {value:'state', label:'MailState', disabled: false, required: true},
                    {value:'postal_code', label:'MailZip', disabled: false, required: true},
                    {value:'start_date', label:'StartDate', disabled: false, required: true},
                    {value:'description', label:'Notes', disabled: false, required: false},
                    {value:'ProjectMgr', label:'ProjectMgr', disabled: false, required: false},
                ],
                'ARCM' : [
                    {value:'name', label:'Name', disabled: false, required: true},
                    {value:'phone', label:'Phone', disabled: false, required: false},
                    {value:'email', label:'EMail', disabled: false, required: false},
                    {value:'street_1', label:'Address', disabled: false, required: false},
                    {value:'city', label:'City', disabled: false, required: false},
                    {value:'state', label:'State', disabled: false, required: false},
                    {value:'postal_code', label:'Zip', disabled: false, required: false},
                    {value:'Contact', label:'Contact', disabled: false, required: false},
                    {value:'terms', label:'PayTermsDescription', disabled: false, required: false},
                ],
                'JC_JOB_MASTER_MC': [
                    {value:'number', label:'Job_Number', disabled: false, required: true},
                    {value:'name', label:'Job_Description', disabled: false, required: false},
                    {value:'street_1', label:'Address_1', disabled: false, required: false},
                    {value:'street_2', label:'Address_2', disabled: false, required: false},
                    {value:'city', label:'City', disabled: false, required: false},
                    {value:'state', label:'State', disabled: false, required: false},
                    {value:'postal_code', label:'Zip_Code', disabled: false, required: false},
                    {value:'start_date', label:'Start_Date', disabled: false, required: false},
                    {value:'completion_date', label:'Complete_Date', disabled: false, required: false},
                    {value:'status', label:'Status_Code', disabled: false, required: false},
                ],
                'CR_CUSTOMER_MASTER_MC': [
                    {value:'name', label:'Name', disabled: false, required: true},
                    {value:'email', label:'Customer_Email', disabled: false, required: true},
                    {value:'Customer_Code', label:'Customer_Code', disabled: false, required: true},
                    {value:'phone', label:'Phone', disabled: false, required: false},
                    {value:'street_1', label:'Address_1', disabled: false, required: false},
                    {value:'street_2', label:'Address_2', disabled: false, required: false},
                    {value:'city', label:'City', disabled: false, required: false},
                    {value:'state', label:'State', disabled: false, required: false},
                    {value:'postal_code', label:'Zip_Code', disabled: false, required: false},
                ],
                'ACO': [
                    {value:'description', label:'Description', disabled: false, required: false},
                    {value:'revenue', label:'Revenue', disabled: false, required: false},
                    {value:'approval_date', label:'Approval Date', disabled: false, required: false},
                    {value:'gross_margin_percentage', label:'Gross Margin%', disabled: false, required: false},
                    // {value:'text_code_id', label:'Sales_Tax_Code', disabled: false, required: true},
                    // {value:'terms', label:'Terms_Code', disabled: false, required: true}
                ],
            },
            projectCustomFields: [],
            companyCustomFields: [],
            contactCustomFields: [],
            fieldMappingError: null,
            loadingMessage: 'Fetching fields',
            isAddButtonDisable: false,
            showSyncedFieldOptions: false,
            showMapFieldOptions: false,
            syncedFieldOptions: [],
            selectedFieldItem: null,
            selectedFieldIndex: null,
            loadingDropdownOptionsMessage: 'Fetching dropdown options',
            editingModuleFieldIndex: null,
            selectedModuleForImport: null,
            isAddButtonDisabled: false,
            fieldMappingNote: '',
            selectedMappingDropdownField : {
                followUpLabel: '',
                thirdParty: '',
            },
            dropdownOptions: [],
            thirdPartyDropdownOptions: [],
            usersList: [],
            dropdownFieldMappingData: [],
            selectedDropdownFieldIndex: null,
        };
    },
    watch: {

    },
    async mounted() {
        this.getTeamUsers();
        this.getProjectCustomFields();
        this.getCompanyCustomFields();
        this.getContactCustomFields();
        await this.getErpIntegrations();
        if(this.connectedErpIntegration === 'vista'){
            this.thirdPartyObjectOptions = this.vistaObjectOption
        }else{
            this.thirdPartyObjectOptions = this.spectrumObjectOption

        }

        $(".import-button-disabled").tooltip();
    },

    methods: {
        getTeamUsers() {
            axios.get(route('api.team-users')).then(({data}) => {
                this.usersList = data.map(user => ({id: user.id, name: user.name}));
            });
        },
        mapDropdownFields(fieldItem, fieldIndex) {
            console.log("field Item", fieldItem, fieldIndex);
            let self = this;
            self.showMapFieldOptions = true;
            self.selectedDropdownFieldIndex = fieldIndex;
            self.selectedMappingDropdownField = fieldItem;
            self.$nextTick(() => {
                $("#loadingOverlayFetchingFieldOptions").fadeIn();
            })
            self.dropdownOptions = self.selectedMappingDropdownField.dropdownOptions;
            let newDropDownOptions = [];
            self.dropdownOptions.map(dropdownOption => {

                newDropDownOptions.push({
                    id: dropdownOption.followup_field_id ?? dropdownOption.id,
                    name: dropdownOption.followup_field_label ?? dropdownOption.name
                })
                console.log("field Item", dropdownOption);
                self.dropdownFieldMappingData.push({
                    id: dropdownOption.followup_field_id ?? dropdownOption.id,
                    followup_label: dropdownOption.name,
                    third_party_id: dropdownOption.agave_field_id ?? null,
                    third_party_label: dropdownOption.agave_field_label ?? null,
                })
            })

            self.dropdownOptions = newDropDownOptions;

            axios.post(route('api.erp-integration-vista-fields.get-project-manager'), {fieldItem: fieldItem}).then(({data}) => {
              console.log("response", data);

                if(data.status == 'success'){
                    self.thirdPartyDropdownOptions = data.dropdownOptions;

                    $("#loadingOverlayFetchingFieldOptions").fadeOut();
                }else{
                    self.thirdPartyDropdownOptions = [];
                    this.getToast(2000).fire({
                        type: 'error',
                        title: 'No Project Managers found on Vista'
                    });
                }
            });


        },
        syncProjectManager(fieldItem, fieldIndex, syncAgain = false){
            let self = this;
            self.syncedFieldOptions = [];
            if(fieldItem.is_custom_field_synced && !syncAgain){
                self.showSyncedFieldOptions = true;
                self.$nextTick(() => {
                    $("#loadingOverlayFetchFieldOptions").fadeIn();
                })
                axios.post(route('api.erp-integration-vista-fields.get-project-manager'), {fieldItem: fieldItem}).then(({data}) => {
                    if(data.status == 'success'){
                        self.syncedFieldOptions = data.syncedFieldOptions;

                        $("#loadingOverlayFetchFieldOptions").fadeOut();
                    }
                });
            }else{
                Swal.fire({
                    title: 'WARNING! Overwrite '+fieldItem.followUpLabel+' List?',
                    text: "This will replace your Custom "+fieldItem.followUpLabel+' list on Followup, with the Project Manager list on Vista',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'Confirm'
                }).then((result) => {
                    if (result.value) {
                        self.$nextTick(() => {
                            if(syncAgain){
                                self.loadingDropdownOptionsMessage = 'Syncing project Manager data';
                                $("#loadingOverlayFetchFieldOptions").fadeIn();
                            }else{
                                self.loadingMessage = 'Syncing project Manager data';
                                $("#loadingOverlayFetchVistaFields").fadeIn();
                            }
                        })
                        fieldItem.is_custom_field_synced = false;
                        axios.post(route('api.erp-integration-vista-fields.get-project-manager'), {fieldItem: fieldItem}).then(({data}) => {
                            if(data.status == 'success'){

                                if(data.synced){
                                    self.fieldMappingData[fieldIndex].is_custom_field_synced = true;
                                    self.syncedFieldOptions = data.syncedFieldOptions;
                                }else{
                                    console.log("some thing went wrong try again later")
                                }
                                self.getErpIntegrations();
                                $("#loadingOverlayFetchVistaFields").fadeOut();
                                $("#loadingOverlayFetchFieldOptions").fadeOut();
                            }
                        });
                    }
                });
            }
            self.selectedFieldItem = fieldItem;
            self.selectedFieldIndex = fieldIndex;

            setTimeout(() => {
                $("#loadingOverlayFetchVistaFields").fadeOut();
            }, 3000)

        },
        // to set the field mapping modal
        viewFieldsMapping(item, index){
            let self = this;
            self.showFieldsMapping = true;
            self.fieldMappingError = null;
            self.fieldMappingNote = '';
            self.loadingMessage = 'Fetching fields';

            if(!item.followUp || !item.thirdParty){
                self.fieldMappingData = []
                self.fieldMappingError = 'Modules are required';
                return false;
            }
            self.$nextTick(() => {
                $("#loadingOverlayFetchVistaFields").fadeIn();
            })
            this.selectedFieldMappingObject = item;
            this.selectedFieldMappingIndex = index;
            if(this.selectedFieldMappingObject.followUp === 'Project'){

                this.followUpFieldsOptions = [{
                    label: 'Project Fields',
                    options: this.projectFields
                }, {
                    label: 'Custom Fields',
                    options: this.projectCustomFields
                }]
                // this.followUpFieldsOptions = [...this.projectFields, ...customFieldOptions];
            }else if(this.selectedFieldMappingObject.followUp === 'Residential-contact'){
                this.followUpFieldsOptions = [{
                    label: 'Contact Fields',
                    options: [...this.contactFields, ...this.residentialContactFields]
                }, {
                    label: 'Custom Fields',
                    options: this.contactCustomFields
                }];
            }else if(this.selectedFieldMappingObject.followUp === 'Company'){
                this.followUpFieldsOptions = [{
                    label: 'Company Fields',
                    options: this.companyFields
                }, {
                    label: 'Contact Fields',
                    options: this.contactFields
                }, {
                    label: 'Custom Fields',
                    options: this.companyCustomFields
                }];
            }else if(this.selectedFieldMappingObject.followUp === 'Project-change-order'){
                this.followUpFieldsOptions = [{
                    label: 'Change Order',
                    options: this.projectChangeOrderFields
                }];
            }
            this.fieldMappingData = [];
            if(this.selectedFieldMappingObject.fieldMappings.length > 0){
                this.selectedFieldMappingObject.fieldMappings.map(mappedField => {
                    this.fieldMappingData.push({
                        erp_integration_field_id: mappedField.erp_integration_field_id,
                        id: mappedField.id,
                        followUp: { value: mappedField.follow_up_field, label :mappedField.follow_up_field_label, object_type:mappedField.follow_up_object_type,  is_custom_field: mappedField.is_custom_field ?? 0},
                        followUpLabel: mappedField.follow_up_field_label,
                        followUpObject: mappedField.follow_up_object_type,
                        direction: mappedField.direction,
                        thirdPartyLabel: mappedField.third_party_field,
                        thirdParty: mappedField.agave_field,
                        status: !!mappedField.status,
                        is_custom_field: !!mappedField.is_custom_field,
                        is_custom_field_dropdown: (mappedField.dropdown_options && mappedField.dropdown_options.length > 0) ? true : !!(mappedField.fieldType == 1 || mappedField.fieldType == 3),
                        dropdownOptions: (mappedField.dropdown_options && mappedField.dropdown_options.length > 0) ? mappedField.dropdown_options : ((this.connectedErpIntegration === 'vista' &&  ['account_manager_id', 'estimator_id', 'take_off_person_id'].includes( mappedField.follow_up_field)) ? this.usersList : []),
                        is_custom_field_synced: !!mappedField.is_custom_field_synced,
                        canChangeDirection: this.userCanChangeDirection(mappedField)
                    })
                })
            }

            if(self.selectedFieldMappingObject.thirdParty && self.selectedFieldMappingObject.followUp){
                const requiredFields = self.agaveFields[self.selectedFieldMappingObject.thirdParty].filter(field => field.required);
                if(requiredFields && requiredFields.length > 0){
                    self.fieldMappingNote = 'Note: Required fields by '+self.connectedErpIntegration+' ('+ requiredFields.map(field => field.label).join(", ")+')';
                }
            }

            if(self.selectedFieldMappingObject.thirdParty == 'ACO'){
                self.thirdPartyFieldsOptions = [];
                self.agaveFields['ACO'].forEach(item => {

                    self.thirdPartyFieldsOptions.push({
                        value: item.value,
                        label: item.label,
                        disabled: false,
                        direction: 'two-ways',
                        canChangeDirection: true,
                    });
                });
                self.$nextTick(() => {
                    $("#loadingOverlayFetchVistaFields").fadeOut();
                })
            }else{

                let payload = {
                    'tableName': item.thirdParty,
                    'service': self.connectedErpIntegration
                }
                axios.post(route('api.erp-integration-vista-spectrum-fields.get'), payload).then(({data}) => {
                    if(data.thirdPartyKeys){
                        self.thirdPartyFieldsOptions = [];
                        const fieldsFromAgave = self.agaveFields[self.selectedFieldMappingObject?.thirdParty] ?? [];
                        data.thirdPartyKeys.forEach(key => {
                            const matchingField = fieldsFromAgave.find(field => field.label === key);

                            self.thirdPartyFieldsOptions.push({
                                value: matchingField ? matchingField.value : key,
                                label: key,
                                disabled: false,
                                direction: matchingField ? 'two-ways' : 'one-way-followup',
                                canChangeDirection: !!matchingField,
                            });
                        });
                        $("#loadingOverlayFetchVistaFields").fadeOut();
                        if(this.connectedErpIntegration == 'vista'){
                            self.thirdPartyFieldsOptions.push({
                                value: 'start_date',
                                label: 'StartDate',
                                disabled: false,
                                direction: 'two-ways'
                            });
                        }

                        self.thirdPartyFieldsOptions.sort((a, b) => a.label.localeCompare(b.label));
                    }
                });
            }

        },
        userCanChangeDirection(fieldItem){
            if(this.connectedErpIntegration == 'vista' && this.selectedFieldMappingObject.followUp == 'Project-change-order'){
                return false;
            }else{
                return !!this.agaveFields[this.selectedFieldMappingObject.thirdParty].some(field => field.value === fieldItem.agave_field);
            }
        },

        // to add new row to erpIntegration modules
        async addModuleMappingData() {
            const self = this;
            await self.disabledOption(self.moduleMappingData)
            const followUpResult = await self.followupObjectOption.filter(val => val.disabled !== true);
            if(followUpResult.length > 0){
                await self.moduleMappingData.push({
                    erp_integration_id: self.erpIntegrationId,
                    id: 0,
                    followUp: null,
                    followUpCustomId: null,
                    direction: this.direction,
                    thirdParty: null,
                    thirdPartyCustomId: null,
                    thirdPartyLabel: null,
                    status: true,
                    fieldMappings: []
                })
            }
        },

        // to add new row to module field mappings
        async addModuleFieldMappingData() {
            const self = this;
            await self.disabledFieldOption(self.fieldMappingData)
            const followUpFieldResult = self.computedFollowUpFieldsOptions.filter(val => val.disabled !== true);
            const thirdPartyFieldResult = self.thirdPartyFieldsOptions.filter(val => val.disabled !== true);
            if(followUpFieldResult.length > 0 && thirdPartyFieldResult.length > 0){
                self.fieldMappingData.push({
                    erp_integration_field_id: self.selectedFieldMappingObject.id,
                    id: 0,
                    followUp: {value: null, label: null, object_type: null, disabled: false, is_custom_field: 0},
                    followUpLabel: null,
                    followUpObject: null,
                    direction: this.fieldDirection,
                    thirdPartyLabel: null,
                    thirdParty: null,
                    status: true,
                    is_custom_field: false,
                    is_custom_field_synced: false,
                    is_custom_field_dropdown: false,
                    dropdownOptions: [],
                })
            }
        },

        // to save/create an erp module in DB
        saveModule(data) {
            if(data.fieldMappings.length > 0){
                const self = this;
                self.isAddButtonDisabled = true;
                let payload =  {
                    erp_integration_id : self.erpIntegrationId,
                    data:data
                }
                axios.post(route('api.erp-integration-fields.create'), payload).then(({data}) => {
                    self.getErpIntegrations();
                    self.isAddButtonDisabled = false;
                });
            }
        },

        // to update the erp module fields in DB
        async updateModule(data) {
            const self = this;
            let payload =  {
                data: data
            }
            await axios.post(route('api.erp-integration-fields.update-vista-module'), payload).then(({data}) => {
                self.getErpIntegrations();
                this.showSaveFieldsButton = false;
            });
        },

        // to complete adding the module field to fieldMappingData
        async addModuleField(index) {
            const fieldObject = this.fieldMappingData[index];
            if(!fieldObject.followUp || !fieldObject.thirdParty){
                this.fieldMappingError = 'Fields are required';
                return false;
            }

            this.fieldMappingData[index].id = index+1;
            await this.disabledFieldOption(this.fieldMappingData)

            if(!this.showSaveFieldsButton){
                this.showSaveFieldsButton = true;
            }
            this.fieldMappingError = null;
            this.editingModuleFieldIndex = false
        },

        // to push the module field to module.fieldMappings
        async saveModuleFields() {
            let self = this;

            const requiredFields = self.agaveFields[this.selectedFieldMappingObject.thirdParty].filter(field => field.required);

            const unmappedRequiredFields = requiredFields.filter(requiredField => {
                return !self.fieldMappingData.some(mapping => mapping.thirdPartyLabel === requiredField.label);
            });

            if(self.fieldMappingData.some(mapping => (!mapping.followUpLabel || !mapping.thirdPartyLabel))){
                this.fieldMappingError = 'Some fields are not mapped';
            }else if (unmappedRequiredFields.length > 0) {
                this.fieldMappingError = '* Missing required fields '+this.connectedErpIntegration+' ('+ unmappedRequiredFields.map(field => field.label).join(", ")+')';
            } else {
                self.moduleMappingData[self.selectedFieldMappingIndex].fieldMappings = self.fieldMappingData.filter(field => field.followUpLabel && field.thirdPartyLabel);

                self.showFieldsMapping = false;
                self.fieldMappingData = [];
                await self.disabledFieldOption(self.fieldMappingData);
                if(self.moduleMappingData[self.selectedFieldMappingIndex].id !== 0) {
                    await self.updateModule(self.moduleMappingData[self.selectedFieldMappingIndex]);
                }

                this.editingModuleFieldIndex = null;
            }
        },

        // to delete the module form DB
        async deleteModule(item) {
            let self = this;
            let payload =  {
                    erp_integration_id : self.erpIntegrationId,
                    field_id : item.id
                }
            await axios.post(route('api.erp-integration-fields.delete'), payload).then(async ({data}) => {
                await self.getErpIntegrations(item.id);
                // await self.getAllErp();
                // self.showButtonMapping = true;
                const objectOptionIndex = self.followupObjectOption.findIndex(val => val.value === item.followUp);
                if(objectOptionIndex !== -1){
                    self.followupObjectOption[objectOptionIndex].disabled = false;
                }
            });
        },

        // to remove the module field from fieldMappingData while editing
        async removeModuleField(index) {
            await this.removeDisabledFieldOption(this.fieldMappingData[index]);
            this.fieldMappingData.splice(index, 1);
            this.showSaveFieldsButton = true;
        },

        returnUrl(val){
            return this.bucketUrl+'erp/'+val+'.png'
        },

        // to change the direction of the module FollowUp to ThirdParty etc.
        changeModuleDirection(){
            switch (this.selectedFieldMappingObject.direction) {
                case 'two-ways':
                    this.selectedFieldMappingObject.direction = 'one-way-followup';
                    break;
                case 'one-way-followup':
                    this.selectedFieldMappingObject.direction = 'one-way-third-party';
                    break;
                case 'one-way-third-party':
                    this.selectedFieldMappingObject.direction = 'two-ways';
                    break;
                default:
                    console.log(`Sorry, we are out`);
            }
            this.showSaveFieldsButton = true;
        },

        // to change the direction of the module fields if the field has agave key
        changeModuleFieldDirection(fieldItem){
            switch (fieldItem.direction) {
                case 'two-ways':
                    fieldItem.direction = 'one-way-followup';
                    break;
                case 'one-way-followup':
                    fieldItem.direction = 'one-way-third-party';
                    break;
                case 'one-way-third-party':
                    fieldItem.direction = 'two-ways';
                    break;
                default:
                    console.log(`Sorry, we are out`);
            }
            this.showSaveFieldsButton = true;
        },

        updateAllData(){
            const self = this;
            let payload =  {
                    third_party_name : 'vista',
                    direction : this.direction,
                    source_truth : this.selectedSourceTruth,
                    sync_status : this.syncStatus
                }
            axios.post(route('api.erp-integration.update'), payload).then(({data}) => {
                // self.erpIntegrationId = data.id;
                // self.getErpIntegrations();
            });
        },

        updateFieldStatus(item){
            let payload =  {
                    status : !item.status,
                    erp_integration_field_id : item.id,
                    erp_integration_id : item.erp_integration_id,
                }
                if(item.id == 0){
                    return false
                }
            axios.post(route('api.erp-integration-fields.update'), payload).then(({data}) => {
            });
        },

        async getErpIntegrations(deletedModuleId = null){
            const self = this;
            await axios.get(route('api.erp-integration.get',{third_party_name: this.connectedErpIntegration})).then( async ({data}) => {
                if(data){
                    self.erpIntegrationId = data.id;
                    self.direction = data.direction
                    self.selectedSourceTruth = data.source_truth
                    self.syncStatus = data.sync_status

                    if(self.moduleMappingData.length > 0){


                        self.moduleMappingData = self.moduleMappingData
                            .filter(moduleMap => {
                                const matchedField = _.find(data.fields, field => (field.follow_up_object === moduleMap.followUp && field.third_party_object === moduleMap.thirdParty));
                                return !!matchedField; // Only include objects where a matching field is found
                            })
                            .map(moduleMap => {
                                const matchedField = _.find(data.fields, field => (field.follow_up_object === moduleMap.followUp && field.third_party_object === moduleMap.thirdParty));
                                const parsedFieldJson = JSON.parse(matchedField.field_json);

                                moduleMap.erp_integration_id = matchedField.erp_integration_id;
                                moduleMap.id = matchedField.id;
                                moduleMap.followUp = matchedField.follow_up_object;
                                moduleMap.followUpCustomId = parsedFieldJson.followUpCustomId;
                                moduleMap.direction = matchedField.direction;
                                moduleMap.thirdParty = matchedField.third_party_object;
                                moduleMap.thirdPartyCustomId = parsedFieldJson.thirdPartyCustomId;
                                moduleMap.thirdPartyLabel = matchedField.third_party_label;
                                moduleMap.status = !!matchedField.status;
                                moduleMap.fieldMappings = matchedField.module_fields ? this.formatModuleFields(matchedField.module_fields) : [];

                                return moduleMap;
                            });


                    }else{
                        self.moduleMappingData = await data.fields.map(val => {
                            const parsedFieldJson = JSON.parse(val.field_json);
                            return {
                                erp_integration_id: val.erp_integration_id,
                                id: val.id,
                                followUp: val.follow_up_object,
                                followUpCustomId: parsedFieldJson.followUpCustomId,
                                direction: val.direction,
                                thirdParty: val.third_party_object,
                                thirdPartyCustomId: parsedFieldJson.thirdPartyCustomId,
                                thirdPartyLabel: val.third_party_label,
                                status: !!val.status,
                                fieldMappings: val.module_fields ? this.formatModuleFields(val.module_fields) : []
                            }
                        })
                    }

                    // await self.disabledOption(data.fields)
                }

            });
        },
        formatModuleFields(moduleMappings){
            return moduleMappings.map(moduleMapping => {
                console.log("module mapping", moduleMapping)
                return {
                ...moduleMapping,
                    followUp:{
                    value:moduleMapping.follow_up_field,
                        label: moduleMapping.follow_up_field_label,
                        object_type:moduleMapping.follow_up_object_type,
                        is_custom_field: moduleMapping.is_custom_field ?? 0,
                        is_custom_field_dropdown: moduleMapping.dropdown_options && moduleMapping.dropdown_options.length > 0 ?  1 : 0,
                        dropdownOptions: moduleMapping.dropdown_options ? moduleMapping.dropdown_options : this.getDropdownOptions(moduleMapping),
                }
                }
            })
        },
        getDropdownOptions(moduleMapping){
            if(moduleMapping.is_custom_field) {
                let customField = null;
                if(moduleMapping.follow_up_object_type === 'Project') {
                    customField = this.projectCustomFields.find(projectCustomField => projectCustomField.value == moduleMapping.follow_up_field)
                }else if(moduleMapping.follow_up_object_type === 'CompanyContact') {
                    customField = this.contactCustomFields.find(contactCustomField => contactCustomField.value == moduleMapping.follow_up_field)
                }else if(moduleMapping.follow_up_object_type === 'Project') {
                    customField = this.companyCustomFields.find(companyCustomField => companyCustomField.value == moduleMapping.follow_up_field)
                }
                return customField ? customField.options : []
            }else if(['account_manager_id', 'estimator_id', 'take_off_person_id'].includes(moduleMapping.follow_up_field) && this.connectedErpIntegration == 'vista') {
                return this.usersList;
            }else{
                return []
            }
        },
        disabledOption(data) {
            let self = this;
            self.followupObjectOption = self.followupObjectOption.map(option => ({...option, disabled: false}));
            self.thirdPartyObjectOptions = self.thirdPartyObjectOptions.map(option => ({...option, disabled: false}));
            data.map(item => {
                const followUpOptionIndex = self.followupObjectOption.findIndex(option => option.custom_id === item.followUpCustomId)
                if(followUpOptionIndex !== -1){
                    self.followupObjectOption[followUpOptionIndex].disabled = true
                }
                const thirdPartyOptionIndex = self.thirdPartyObjectOptions.findIndex(thirdPartyOption => thirdPartyOption.custom_id === item.thirdPartyCustomId)
                if(thirdPartyOptionIndex !== -1){
                    self.thirdPartyObjectOptions[thirdPartyOptionIndex].disabled = true
                }
            })
        },

        disabledFieldOption(data){
            this.thirdPartyFieldsOptions = this.thirdPartyFieldsOptions.map(option => ({...option, disabled: false}));
            for (let j = 0; j < data.length; j++) {

                const thirdPartyFieldOptionIndex = this.thirdPartyFieldsOptions.findIndex(item => item.value === data[j].thirdParty);
                if(thirdPartyFieldOptionIndex !== -1){
                    this.thirdPartyFieldsOptions[thirdPartyFieldOptionIndex].disabled = true;
                }
            }
        },

        removeDisabledFieldOption(data){
            const followupFieldOptionIndex = this.followUpFieldsOptions.findIndex(item => item.value === data.followUp);
            if(followupFieldOptionIndex !== -1){
                this.followUpFieldsOptions[followupFieldOptionIndex].disabled = false;
            }
            const thirdPartyFieldOptionIndex = this.thirdPartyFieldsOptions.findIndex(item => item.value === data.thirdParty);
            if(thirdPartyFieldOptionIndex !== -1){
                this.thirdPartyFieldsOptions[thirdPartyFieldOptionIndex].disabled = false;
            }
        },

        changeModules(data, type, index){
            if(this.connectedErpIntegration === 'vista') {
                if(type === 'followup'){
                    if((data.followUp === 'Project' && data.thirdParty && data.thirdParty !== 'JCJM') || (data.thirdParty && data.thirdParty === 'JCJM' && data.followUp !== 'Project')){
                        this.getToast(2000).fire({
                            type: 'error',
                            title: 'Project can only be mapped to JC JOB MASTER'
                        });
                        this.moduleMappingData[index].followUp = null;
                        this.moduleMappingData[index].followUpCustomId = null;

                    }else{
                        this.moduleMappingData[index].followUp = data.followUp;
                        this.moduleMappingData[index].followUpCustomId = this.followupObjectOption.find(option => option.value === data.followUp).custom_id;
                    }
                }else{

                    if((data.thirdParty === 'JCJM' && data.followUp && data.followUp !== 'Project') || data.thirdParty !== 'JCJM' && data.followUp && data.followUp === 'Project'){
                        this.getToast(2000).fire({
                            type: 'error',
                            title: 'Project can only be mapped to JC JOB MASTER'
                        });
                        this.moduleMappingData[index].thirdParty = null;
                        this.moduleMappingData[index].thirdPartyCustomId = null;
                    }else{
                        this.moduleMappingData[index].thirdParty = data.thirdParty;
                        this.moduleMappingData[index].thirdPartyCustomId = this.thirdPartyObjectOptions.find(option => option.value === data.thirdParty && !option.disabled).custom_id;
                        this.moduleMappingData[index].thirdPartyLabel = this.thirdPartyObjectOptions.find(option => option.value === data.thirdParty).label;

                    }
                }
            }else if(this.connectedErpIntegration === 'spectrum'){
                if(type === 'followup'){
                    if((data.followUp === 'Project' && data.thirdParty && data.thirdParty !== 'JC_JOB_MASTER_MC') || (data.thirdParty && data.thirdParty === 'JC_JOB_MASTER_MC' && data.followUp !== 'Project')){
                        this.getToast(2000).fire({
                            type: 'error',
                            title: 'Project can only be mapped to JC JOB MASTER'
                        });
                        this.moduleMappingData[index].followUp = null;
                        this.moduleMappingData[index].followUpCustomId = null;

                    }else{
                        this.moduleMappingData[index].followUp = data.followUp;
                        this.moduleMappingData[index].followUpCustomId = this.followupObjectOption.find(option => option.value === data.followUp).custom_id;
                    }
                }else{

                    if((data.thirdParty === 'JC_JOB_MASTER_MC' && data.followUp && data.followUp !== 'Project') || data.thirdParty !== 'JC_JOB_MASTER_MC' && data.followUp && data.followUp === 'Project'){
                        this.getToast(2000).fire({
                            type: 'error',
                            title: 'Project can only be mapped to JC JOB MASTER'
                        });
                        this.moduleMappingData[index].thirdParty = null;
                        this.moduleMappingData[index].thirdPartyCustomId = null;
                    }else{
                        this.moduleMappingData[index].thirdParty = data.thirdParty;
                        this.moduleMappingData[index].thirdPartyCustomId = this.thirdPartyObjectOptions.find(option => option.value === data.thirdParty && !option.disabled).custom_id;
                        this.moduleMappingData[index].thirdPartyLabel = this.thirdPartyObjectOptions.find(option => option.value === data.thirdParty).label;

                    }
                }
            }

            this.disabledOption(this.moduleMappingData);
        },
        changeFields(data, type, index){
            if(type === 'followup'){


                let followUpSelectedOption = data.followUp;
                this.fieldMappingData[index].is_custom_field = followUpSelectedOption.is_custom_field;
                this.fieldMappingData[index].is_custom_field_dropdown = !!(followUpSelectedOption?.fieldType === 1 || followUpSelectedOption?.fieldType === 3);
                this.fieldMappingData[index].dropdownOptions = followUpSelectedOption.dropdownOptions;
                // this.fieldMappingData[index].followUp = data.followUp;
                this.fieldMappingData[index].followUpLabel = followUpSelectedOption.label;
                this.fieldMappingData[index].followUpObject = followUpSelectedOption.object_type;
            }else{
                const thirdPartySelectedOption = this.thirdPartyFieldsOptions.find(option => option.value === data.thirdParty)
                this.fieldMappingData[index].thirdParty = data.thirdParty;
                this.fieldMappingData[index].thirdPartyLabel = thirdPartySelectedOption.label;
                this.fieldMappingData[index].direction = thirdPartySelectedOption.direction;
                this.fieldMappingData[index].canChangeDirection = thirdPartySelectedOption.canChangeDirection;
            }
            this.fieldMappingError = null;
            this.disabledFieldOption(this.fieldMappingData);
        },
        getProjectCustomFields(){
            let self = this;
            let params = `?project=true`;
            axios.get(route('api.project-custom-field.index') + params).then(({data}) => {
                if(data.data.length){
                    data.data.map(field =>{
                        // if(field.type === 3)
                        self.projectCustomFields.push({value:field.id, label: field.label_value, disabled: false, is_custom_field: true, fieldType: field.type, options: field.options, object_type: 'Project'});
                    })
                }

            });
        },
        getCompanyCustomFields(){
            let self = this;
            let params = `?company=true`;
            axios.get(route('api.company-custom-field.index') + params).then(({data}) => {
                if(data.data.length){
                    data.data.map(field =>{
                        // if(field.type === 3)
                        self.companyCustomFields.push({value:field.id, label: field.label_value, disabled: false, is_custom_field: true, object_type: 'Company'});
                    })
                }
            });
        },
        getContactCustomFields(){
            let self = this;
            let params = `?contact=true`;
            axios.get(route('api.contact-custom-field.index') + params).then(({data}) => {
                if(data.data.length){
                    data.data.map(field =>{
                        // if(field.type === 3)
                            self.contactCustomFields.push({value:field.id, label: field.label_value, disabled: false, is_custom_field: true, object_type: 'CompanyContact'});
                    })
                }
            });
        },
        editModuleField(index){
            this.editingModuleFieldIndex = index;
        },
        openImportCustomersModal(item){
            this.selectedModuleForImport = item.followUp;
            $("#importCustomerConfirmationModal").modal('show');
        },
        importCustomers(item){

            $("#importCustomerConfirmationModal").modal('hide');
            let self = this;
            let importRoute = self.connectedErpIntegration == 'vista' ? 'vista.import-customers' : 'api.spectrum.import-customers'
            axios.post(route(importRoute, {type: this.selectedModuleForImport})).then(response => {
                if(response.data.status == "success"){
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: 'Something went wrong'

                    });
                }
            });

        },
        closeImportCustomersModal(){
            $("#importCustomerConfirmationModal").modal('hide');
        },
        isFieldDisabled(fieldMappingData, option){
            let isDisabled = option.disabled;
            fieldMappingData.map(fieldMapping => {
                if(fieldMapping.followUpLabel && fieldMapping.followUp.label == option.label && fieldMapping.followUp.object_type == option.object_type){
                    isDisabled = true;
                }
            })
            return isDisabled;
        },
        changeDropdownMappingField(fieldIndex, option){

            console.log(fieldIndex, option)
            this.dropdownFieldMappingData[fieldIndex].third_party_label = this.thirdPartyDropdownOptions.find(thirdPartyDropdownOption => thirdPartyDropdownOption.ProjectMgr == option.third_party_id)?.Name ?? ''
        },

        getDropdownOptionsForComputed(item){
            if(item.is_custom_field) {
                let customField = null;
                if(item.object_type === 'Project') {
                    customField = this.projectCustomFields.find(projectCustomField => projectCustomField.value == item.value)
                }else if(item.object_type === 'CompanyContact') {
                    customField = this.contactCustomFields.find(contactCustomField => contactCustomField.value == item.value)
                }else if(item.object_type === 'Company') {
                    customField = this.companyCustomFields.find(companyCustomField => companyCustomField.value == item.value)
                }
                return customField ? customField.options : []
            }else if(['account_manager_id', 'estimator_id', 'take_off_person_id'].includes(item.value) && this.connectedErpIntegration == 'vista') {
                return this.usersList;
            }else{
                return []
            }
        },

        saveDropdownOptions() {
            let self = this;
            self.fieldMappingData[self.selectedDropdownFieldIndex].dropdownOptions = self.dropdownFieldMappingData;
            self.showMapFieldOptions = false;
            self.selectedDropdownFieldIndex = null;
            self.selectedMappingDropdownField =  {
                followUpLabel: '',
                thirdParty: '',
            };
            self.dropdownOptions = [];
            self.thirdPartyDropdownOptions = [];
        }
    },
    computed: {
        computedFollowUpFieldsOptions() {

            return this.followUpFieldsOptions.map(group => ({
                label: group.label,
                options: group.options.map(option =>{
                    return {
                        value: {
                            value:option.value,
                            label: option.label,
                            object_type: option.object_type,
                            is_custom_field: option.is_custom_field ?? 0,
                            fieldType: option.fieldType ?? null,
                            dropdownOptions: this.getDropdownOptionsForComputed(option),
                        },
                        label: option.label,
                        disabled: this.isFieldDisabled(this.fieldMappingData, option),
                    }
                })
            }));
        },
    },
}
</script>
<style scoped>
#loadingOverlayFetchVistaFields, #loadingOverlayFetchFieldOptions{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    display: none;
    background: rgb(0 0 0 / 57%);
}

.cv-spinner {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.spinner {
    width: 40px;
    height: 40px;
    border: 4px #ddd solid;
    border-top: 4px #2e93e6 solid;
    border-radius: 50%;
    animation: sp-anime 0.8s infinite linear;
}
img.and-logic-logo {
    width: 100%;
    max-width: 65px;
    height: auto;
    transition: all .3s linear;
    filter: invert(26%) sepia(89%) saturate(1583%) hue-rotate(95deg) brightness(96%) contrast(106%);
}
.mapping-table {
    max-height: 50vh;
    overflow: auto;
}
@keyframes sp-anime {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(359deg);
    }
}
</style>
